// src/services/preloader.js - טעינה מוקדמת חכמה

import api from './api';
let globalPreloadStarted = false; // ← הוסף את זה כאן!
class PreloaderService {
  constructor() {
    this.isPreloading = false;
    this.preloadedCategories = new Set();
    this.priorityCategories = ['study-funds', 'pension-savings', 'investment-funds'];
  }

  /**
   * 🚀 טעינה מוקדמת של קטגוריות עיקריות
   */
async preloadEssentialData() {
  // 🛡️ בדיקה כפולה - גם flag גלובלי וגם instance
  if (globalPreloadStarted || this.isPreloading) {
   
    return;
  }

  globalPreloadStarted = true; // ← סמן שהתחלנו
  this.isPreloading = true;

  try {
    // שלב 1: טעינת הקטגוריות הפופולריות במקביל
    const preloadPromises = this.priorityCategories.map(async (category) => {
      const startTime = performance.now();
      
      try {
        // טעינה במקביל של הקטגוריה
        await api.getProductsByCategory(category, { limit: 50 });
        
        this.preloadedCategories.add(category);
        const duration = Math.round(performance.now() - startTime);
      
        
      } catch (error) {
        console.warn(`⚠️ Failed to preload ${category}:`, error.message);
      }
    });

    // המתנה לכל הקטגוריות העיקריות
    await Promise.allSettled(preloadPromises);

    // שלב 2: טעינת נתונים נוספים (ברקע)
    this.preloadSecondaryData();

  } catch (error) {
    console.error('❌ Preload failed:', error);
  } finally {
    this.isPreloading = false;
  }
}

  /**
   * 📊 טעינה מוקדמת של נתונים משניים (ברקע)
   */
  async preloadSecondaryData() {
    // המתנה קצרה כדי לא להפריע לטעינה העיקרית
    await new Promise(resolve => setTimeout(resolve, 2000));

  
    try {
      // קטגוריות משניות
      const secondaryCategories = ['insurance-savings', 'pension-plans', 'child-savings'];
      
      const secondaryPromises = secondaryCategories.map(async (category) => {
        try {
          await api.getProductsByCategory(category, { limit: 30 });
          this.preloadedCategories.add(category);
          
        } catch (error) {
          console.warn(`⚠️ Secondary preload failed for ${category}:`, error.message);
        }
      });

      await Promise.allSettled(secondaryPromises);

      // חיפושים פופולריים
      const popularSearches = ['מנורה', 'הראל', 'כלל', 'מיטב'];
      const searchPromises = popularSearches.map(async (term) => {
        try {
          await api.searchProducts(term, { limit: 10 });
        
        } catch (error) {
          console.warn(`⚠️ Search preload failed for ${term}:`, error.message);
        }
      });

      await Promise.allSettled(searchPromises);

    } catch (error) {
      console.warn('⚠️ Secondary preload failed:', error);
    }
  }

  /**
   * 🎯 טעינה מוקדמת של קטגוריה ספציפית
   */
  async preloadCategory(categoryId) {
    if (this.preloadedCategories.has(categoryId)) {
    
      return;
    }


  
    
    try {
      await api.getProductsByCategory(categoryId, { limit: 100 });
      this.preloadedCategories.add(categoryId);
     
    } catch (error) {
      console.warn(`⚠️ Failed to preload category ${categoryId}:`, error.message);
    }
  }

  /**
   * 📈 טעינה מוקדמת של קונפיגורציות טבלאות
   */
  async preloadTableConfigurations() {
   

    // הקונפיגורציות הפופולריות ביותר
    const popularConfigs = [
      { category: 'study-funds', fundIds: [962, 964, 880, 12535, 456] },
      { category: 'study-funds', fundIds: [14862, 13853, 13342, 14668, 13873] },
      { category: 'pension-savings', fundIds: [9730, 12532, 7215, 9916, 9651] },
      { category: 'pension-savings', fundIds: [14858, 15419, 13855, 13946, 13501] }
    ];

    const configPromises = popularConfigs.map(async (config) => {
      try {
        await api.getProductsByIds(config.fundIds, config.category);
        
      } catch (error) {
        console.warn(`⚠️ Config preload failed:`, error.message);
      }
    });

    await Promise.allSettled(configPromises);

  }

  /**
   * 🔄 מעקב אחר סטטוס הטעינה המוקדמת
   */
  getPreloadStatus() {
    return {
      isPreloading: this.isPreloading,
      preloadedCategories: Array.from(this.preloadedCategories),
      totalPreloaded: this.preloadedCategories.size,
      progress: Math.round((this.preloadedCategories.size / 6) * 100) // 6 קטגוריות סה"כ
    };
  }

  /**
   * 🚀 התחלה אוטומטית של טעינה מוקדמת
   */
  startAutoPreload() {
    // המתנה קצרה לאחר טעינת הדף
    setTimeout(() => {
      this.preloadEssentialData();
    }, 1000);

    // טעינה מוקדמת של קונפיגורציות אחרי 3 שניות
    setTimeout(() => {
      this.preloadTableConfigurations();
    }, 3000);
  }
}

// יצירת instance יחיד
const preloader = new PreloaderService();

export default preloader;